export default __webpack_public_path__ + "static/media/om-namah-shivaya.4e079003.mp3";